import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { formatDate } from 'helpers/helpers'
import { httpOk, GET } from 'helpers/api'

// История статусов документа: кто создал, кто провёл, кто удалил и когда.
// Один компонент на все типы документов — тип документа передаётся кодом
// таблицы (entity), как его понимает /document-status-history на бэке.
function DocumentStatusHistory({ entity, documentId, setDocumentId }) {
	const { t } = useTranslation()

	const [history, setHistory] = useState([])

	async function getHistory() {
		const response = await GET(`/document-status-history/${entity}/${documentId}`, {}, { loader: true })
		if (httpOk(response)) setHistory(response.data?.data ?? [])
	}

	function toggleModal() {
		setHistory([])
		setDocumentId(null)
	}

	useEffect(() => {
		if (entity && documentId) getHistory()
	}, [entity, documentId]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{/* MODAL DOCUMENT STATUS HISTORY */}
			<Modal show={!!documentId} animation={false} centered size="lg"
				onHide={() => toggleModal()}>
				<Modal.Header closeButton>
					<Modal.Title>{t('document_status_history')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '30%' }}>{t('status')}</th>
									<th style={{ 'width': '25%' }}>{t('user')}</th>
									<th style={{ 'width': '20%' }} className="text-center">{t('date')}</th>
									<th style={{ 'width': '25%' }}>{t('comment')}</th>
								</tr>
							</thead>
							<tbody>
								{history.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>
											{item.from_status_name &&
												<span className="text-muted">{item.from_status_name} → </span>
											}
											{/* Статус сменился не всегда: правка документа статус не меняет,
												и в такой строке показываем само действие */}
											<span className={`badge bg-${item.to_status_color ? item.to_status_color : 'secondary'}`}>
												{item.to_status_name
													? item.to_status_name
													: (item.action_name_key ? t(item.action_name_key) : item.action)}
											</span>
										</td>
										<td className="td-ellipsis">{item.created_by}</td>
										<td className="text-center text-nowrap">
											{formatDate(item.created_at, 'dd.MM.yy HH:mm:ss')}
										</td>
										<td className="td-ellipsis">
											{[item.deletion_reason_name, item.comment].filter(i => !!i).join(' · ')}
										</td>
									</tr>
								))}
								{history.length === 0 &&
									<tr>
										<td colSpan="5" className="text-center">{t('no_data')}</td>
									</tr>
								}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL DOCUMENT STATUS HISTORY */}
		</>
	)
}

export default DocumentStatusHistory
